import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateNetworkContent, deleteNetworkContent, duplicateNetworkContent } from './redux/networkcontent.actions';
import { FullNetworkContent } from './redux/networkcontent.selectors';
import { StyledStyledSideBarContainer, Stack, Surface, SmartContainer } from '../../styles/Containers';
import { FormInput } from '../../components/Forms/FormInput';
import { PublishingForm } from '../../components/Publishing/PublishingForm';
import { NetworkProductSelector } from '../NetworkProducts/NetworkProductSelector';
import { StyledP } from '../../styles/StyledHTML';

export const NetworkContentForm = ({ item, childrenMain, childrenSide }) => {

    const dispatch = useDispatch();
    const store = FullNetworkContent();

    // Name
    const [name, setName] = useState('');
    const [products, setProducts] = useState([]);


    // Validate
    let disableSubmit = !name;

    // ---------------------------
    // Effects
    // ---------------------------

    // Sync Props
    useEffect(() => {
        if (item?.name) setName(item.name);
        else setName('');

        if (item?.meta?.products) setProducts(item.meta.products);
        else setProducts([]);
    }, [item])


    // --------------------------
    // Interactions
    // --------------------------

    const handleSubmit = (publishing) => {


        // Payload
        const payload = {
            name,
            status: publishing.status,
            publishedAt: publishing.publishedAt,
            unpublishedAt: publishing.unpublishedAt,
            meta: {
                products
            }
        }
        dispatch(updateNetworkContent(item.id, payload));
    }

    // --------------------------
    // Slots
    // --------------------------

    const renderMainContentChildren = () => {
        if (!childrenMain) return (<div></div>)
        return (<SmartContainer>{childrenMain}</SmartContainer>)
    }

    const renderSideContentChildren = () => {
        if (!childrenSide) return (<div></div>)
        return (<SmartContainer>{childrenSide}</SmartContainer>)
    }




    // --------------------------
    // Render Form
    // --------------------------

    return (
        <StyledStyledSideBarContainer thinking={store?.createLoading || store?.updateLoading || store?.duplicateLoading} minWidth="300px">
            <Stack>
                <Surface>
                    <Stack>
                        <FormInput label="Name" type="text" onChange={setName} value={name} />
                    </Stack>
                </Surface>
                {renderMainContentChildren()}
            </Stack>
            <SmartContainer>
                <Stack>
                    <Surface>
                        <PublishingForm
                            item={item}
                            onSubmit={handleSubmit}
                            disable={disableSubmit}
                            deleteAction={deleteNetworkContent}
                            duplicateAction={duplicateNetworkContent}
                            selector={FullNetworkContent}
                            route="/network/content"
                        />
                    </Surface>
                    <Surface>
                        <StyledP>Restrict By Product Purchase</StyledP>
                        <NetworkProductSelector value={products} onChange={(v) => setProducts(v)} />
                    </Surface>
                    {renderSideContentChildren()}
                </Stack>

            </SmartContainer>
        </StyledStyledSideBarContainer>
    )
}